import * as actionTypes from "./ActionTypes";

export const changeShowDialogsAction = (key, value) => {
  return { type: actionTypes.ORG_CHANGE_SHOW_DIALOGS, key, value };
};

export const clearStateAction = (state) => {
  return { type: actionTypes.ORG_CLEAR_STATE, state };
};

export const getAllTenantsAction = (data) => {
  return { type: actionTypes.ORG_GET_ALL_TENANTS, data };
};
export const getAllTenantsSuccessAction = (res) => {
  return { type: actionTypes.ORG_GET_ALL_TENANTS_SUCCESS, res };
};
export const getAllTenantsFailAction = (error) => {
  return { type: actionTypes.ORG_GET_ALL_TENANTS_FAIL, error };
};

export const comparePolygonsChartAction = (data) => {
  return { type: actionTypes.COMPARE_POLYGONS_CHART, data };
};
export const comparePolygonsChartSuccessAction = (res) => {
  return { type: actionTypes.COMPARE_POLYGONS_CHART_SUCCESS, res };
};
export const comparePolygonsChartFailAction = (error) => {
  return { type: actionTypes.COMPARE_POLYGONS_CHART_FAIL, error };
};

export const addTenantAction = (data) => {
  return { type: actionTypes.ORG_ADD_TENANT, data };
};
export const addTenantSuccessAction = (res) => {
  return { type: actionTypes.ORG_ADD_TENANT_SUCCESS, res };
};
export const addTenantFailAction = (error) => {
  return { type: actionTypes.ORG_ADD_TENANT_FAIL, error };
};

export const editTenantAction = (data) => {
  return { type: actionTypes.ORG_EDIT_TENANT, data };
};
export const editTenantSuccessAction = (res) => {
  return { type: actionTypes.ORG_EDIT_TENANT_SUCCESS, res };
};
export const editTenantFailAction = (error) => {
  return { type: actionTypes.ORG_EDIT_TENANT_FAIL, error };
};

export const editOrgAction = (data) => {
  return { type: actionTypes.ORG_EDIT_ORGANIZATION, data };
};
export const editOrgSuccessAction = (res) => {
  return { type: actionTypes.ORG_EDIT_ORGANIZATION_SUCCESS, res };
};
export const editOrgFailAction = (error) => {
  return { type: actionTypes.ORG_EDIT_ORGANIZATION_FAIL, error };
};

export const getOrgByIdAction = (data) => {
  return { type: actionTypes.ORG_GET_ORGANIZATION_BY_ID, data };
};
export const getOrgByIdSuccessAction = (res) => {
  return { type: actionTypes.ORG_GET_ORGANIZATION_BY_ID_SUCCESS, res };
};
export const getOrgByIdFailAction = (error) => {
  return { type: actionTypes.ORG_GET_ORGANIZATION_BY_ID_FAIL, error };
};

export const changeTenantActivationAction = (data) => {
  return { type: actionTypes.ORG_CHANGE_TENANT_ACTIVATION, data };
};
export const changeTenantActivationSuccessAction = (res) => {
  return { type: actionTypes.ORG_CHANGE_TENANT_ACTIVATION_SUCCESS, res };
};
export const changeTenantActivationFailAction = (error) => {
  return { type: actionTypes.ORG_CHANGE_TENANT_ACTIVATION_FAIL, error };
};

export const deleteTenantAction = (data) => {
  return { type: actionTypes.ORG_DELETE_TENANT, data };
};
export const deleteTenantSuccessAction = (res) => {
  return { type: actionTypes.ORG_DELETE_TENANT_SUCCESS, res };
};
export const deleteTenantFailAction = (error) => {
  return { type: actionTypes.ORG_DELETE_TENANT_FAIL, error };
};

export const getTenantByIdAction = (data) => {
  return { type: actionTypes.ORG_GET_TENANT_BY_ID, data };
};
export const getTenantByIdSuccessAction = (res) => {
  return { type: actionTypes.ORG_GET_TENANT_BY_ID_SUCCESS, res };
};
export const getTenantByIdFailAction = (error) => {
  return { type: actionTypes.ORG_GET_TENANT_BY_ID_FAIL, error };
};

export const getOrganizationUserAction = (data) => {
  return { type: actionTypes.ORG_GET_ORGANIZATION_USER, data };
};
export const getOrganizationUserSuccessAction = (res) => {
  return { type: actionTypes.ORG_GET_ORGANIZATION_USER_SUCCESS, res };
};
export const getOrganizationUserFailAction = (error) => {
  return { type: actionTypes.ORG_GET_ORGANIZATION_USER_FAIL, error };
};

export const getTenantUserAction = (data) => {
  return { type: actionTypes.ORG_GET_TENANT_USER, data };
};
export const getTenantUserSuccessAction = (res) => {
  return { type: actionTypes.ORG_GET_TENANT_USER_SUCCESS, res };
};
export const getTenantUserFailAction = (error) => {
  return { type: actionTypes.ORG_GET_TENANT_USER_FAIL, error };
};

export const updateOrgUserAction = (data) => {
  return { type: actionTypes.ORG_UPDATE_ORGANIZATION_USER, data };
};
export const updateOrgUserSuccessAction = (res) => {
  return { type: actionTypes.ORG_UPDATE_ORGANIZATION_USER_SUCCESS, res };
};
export const updateOrgUserFailAction = (error) => {
  return { type: actionTypes.ORG_UPDATE_ORGANIZATION_USER_FAIL, error };
};

export const updateTenantUserAction = (data) => {
  return { type: actionTypes.ORG_UPDATE_TENANT_USER, data };
};
export const updateTenantUserSuccessAction = (res) => {
  return { type: actionTypes.ORG_UPDATE_TENANT_USER_SUCCESS, res };
};
export const updateTenantUserFailAction = (error) => {
  return { type: actionTypes.ORG_UPDATE_TENANT_USER_FAIL, error };
};

export const changeTenantPasswordAction = (data) => {
  return { type: actionTypes.ORG_CHANGE_TENANT_PASSWORD, data };
};
export const changeTenantPasswordSuccessAction = (res) => {
  return { type: actionTypes.ORG_CHANGE_TENANT_PASSWORD_SUCCESS, res };
};
export const changeTenantPasswordFailAction = (error) => {
  return { type: actionTypes.ORG_CHANGE_TENANT_PASSWORD_FAIL, error };
};

export const getUserTokenAction = (data) => {
  return { type: actionTypes.ORG_GET_USER_TOKEN, data };
};
export const getUserTokenSuccessAction = (res) => {
  return { type: actionTypes.ORG_GET_USER_TOKEN_SUCCESS, res };
};
export const getUserTokenFailAction = (error) => {
  return { type: actionTypes.ORG_GET_USER_TOKEN_FAIL, error };
};

export const getUserTokenByTenantIdAction = (data) => {
  return { type: actionTypes.ORG_MNG_GET_USER_TOKEN_BY_TENANT_ID, data };
};

export const getOrganizationUsageAction = (data) => {
  return { type: actionTypes.ORG_GET_ORGANIZATION_USAGE, data };
};
export const getOrganizationUsageSuccessAction = (res, interval) => {
  return { type: actionTypes.ORG_GET_ORGANIZATION_USAGE_SUCCESS, res, interval };
};
export const getOrganizationUsageFailAction = (error) => {
  return { type: actionTypes.ORG_GET_ORGANIZATION_USAGE_FAIL, error };
};

export const downloadUsageAction = (data) => {
  return { type: actionTypes.ORG_DOWNLOAD_USAGE, data };
};
export const downloadUsageSuccessAction = (res) => {
  return { type: actionTypes.ORG_DOWNLOAD_USAGE_SUCCESS, res };
};
export const downloadUsageFailAction = (error) => {
  return { type: actionTypes.ORG_DOWNLOAD_USAGE_FAIL, error };
};


export const getOrgPOCAction = (data) => {
  return { type: actionTypes.ORG_GET_ORG_POC, data };
};
export const getOrgPOCSuccessAction = (res) => {
  return { type: actionTypes.ORG_GET_ORG_POC_SUCCESS, res };
};
export const getOrgPOCFailAction = (error) => {
  return { type: actionTypes.ORG_GET_ORG_POC_FAIL, error };
};

export const updateOrgPOCAction = (data) => {
  return { type: actionTypes.ORG_UPDATE_ORG_POC, data };
};
export const updateOrgPOCSuccessAction = (res) => {
  return { type: actionTypes.ORG_UPDATE_ORG_POC_SUCCESS, res };
};
export const updateOrgPOCFailAction = (error) => {
  return { type: actionTypes.ORG_UPDATE_ORG_POC_FAIL, error };
};

export const addOrgPOCTypeAction = (data) => {
  return { type: actionTypes.ORG_ADD_ORG_POC, data };
};
export const addOrgPOCTypeSuccessAction = (res) => {
  return { type: actionTypes.ORG_ADD_ORG_POC_SUCCESS, res };
};
export const addOrgPOCTypeFailAction = (error) => {
  return { type: actionTypes.ORG_ADD_ORG_POC_FAIL, error };
};

export const removeOrgPOCTypeAction = (data) => {
  return { type: actionTypes.ORG_REMOVE_ORG_POC, data };
};
export const removeOrgPOCTypeSuccessAction = (res) => {
  return { type: actionTypes.ORG_REMOVE_ORG_POC_SUCCESS, res };
};
export const removeOrgPOCTypeFailAction = (error) => {
  return { type: actionTypes.ORG_REMOVE_ORG_POC_FAIL, error };
};

export const deliveryReportAction = (data) => {
  return { type: actionTypes.DELIVERY_REPORT, data };
};
export const deliveryReportSuccessAction = (res) => {
  return { type: actionTypes.DELIVERY_REPORT_SUCCESS, res };
};
export const deliveryReportFailAction = (error) => {
  return { type: actionTypes.DELIVERY_REPORT_FAIL, error };
};


export const deliveryCoordinatesReportAction = (data) => {
    return { type: actionTypes.DELIVERY_COORDINATE_REPORT, data };
};
export const deliveryCoordinatesReportSuccessAction = (res) => {
    return { type: actionTypes.DELIVERY_COORDINATE_REPORT_SUCCESS, res };
};
export const deliveryCoordinatesReportFailAction = (error) => {
    return { type: actionTypes.DELIVERY_COORDINATE_REPORT_FAIL, error };
};

export const getTokenAction = (data) => {
    return { type: actionTypes.GET_TOKEN, data };
};
export const getTokenSuccessAction = (res) => {
    return { type: actionTypes.GET_TOKEN_SUCCESS, res };
};
export const    getTokenFailAction = (error) => {
    return { type: actionTypes.GET_TOKEN_FAIL, error };
};

export const getTokenForOrganizationAction = (data) => {
    return { type: actionTypes.GET_TOKEN_FOR_ORGANIZATION, data };
};
export const getTokenForOrganizationSuccessAction = (res) => {
    return { type: actionTypes.GET_TOKEN_FOR_ORGANIZATION_SUCCESS, res };
};
export const getTokenForOrganizationFailAction = (error) => {
    return { type: actionTypes.GET_TOKEN_FOR_ORGANIZATION_FAIL, error };
};